import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RealEstateProject } from '../../models/real-estate-project.model';
import {
  REAL_ESTATE_DEPARTMENTS,
  FUNDING_TYPES,
  PRJ_EXPENDITURE_TYPES,
  UPDATE_TYPES_CHECKBOX,
  UPDATE_REVISION,
  REGIONS,
} from '../common/real-estate-form-options';

@Component({
  selector: 'app-real-estate-project-title',
  templateUrl: './real-estate-project-title.component.html',
  styleUrls: ['./real-estate-project-title.component.scss'],
  standalone: false,
})
export class RealEstateProjectTitleComponent implements OnInit, OnChanges {
  @Input() realEstateTitleForm: FormGroup;
  @Input() reviewMode = false;
  @Input() projectData: any; // Previous version project data
  @Input() formStatus: string;

  realEstateProject: RealEstateProject;
  realEstateDepartments = REAL_ESTATE_DEPARTMENTS;
  fundingTypes = FUNDING_TYPES;
  filteredFundingTypes = FUNDING_TYPES; // Filtered funding types based on version
  fundingType = '';
  realEstateSelected = false;
  landServicesSelected = false;
  expenditureTypes = PRJ_EXPENDITURE_TYPES;
  updateTypesCheckBox = UPDATE_TYPES_CHECKBOX;
  updateRevision = UPDATE_REVISION;
  regions = REGIONS;
  advFundingSelected = false;

  constructor(private fb: FormBuilder) {
    this.realEstateProject = new RealEstateProject();
  }

  ngOnInit() {
    this.setupDepartmentSubscription();
    this.setupFundingTypeSubscription();
    this.updateFilteredFundingTypes();
  }

  private setupDepartmentSubscription() {
    const realEstateDepartmentControl = this.realEstateTitleForm.get('realEstateDepartment');
    if (realEstateDepartmentControl) {
      realEstateDepartmentControl.valueChanges.subscribe((value) => {
        this.realEstateProject.Department = value;
        this.realEstateSelected = value === 'REAL_ESTATE';
        this.landServicesSelected = value === 'LAND_SERVICES';
        // Update filtered funding types when department changes
        this.updateFilteredFundingTypes();
      });
    }
  }

  private setupFundingTypeSubscription() {
    const fundingTypeControl = this.realEstateTitleForm.get('fundingType');
    if (fundingTypeControl) {
      fundingTypeControl.valueChanges.subscribe((value) => {
        this.realEstateProject.Funding_Type = value;
        if (value.includes('ADVANCE')) {
          this.advFundingSelected = true;
        } else {
          this.advFundingSelected = false;
        }
      });
    }
  }

  onCheckboxChange(selected: string): void {
    const fmControl = this.realEstateTitleForm.get('fm');
    const pmControl = this.realEstateTitleForm.get('pm');
    const acquisitionControl = this.realEstateTitleForm.get('acquisition');
    const disposalControl = this.realEstateTitleForm.get('disposal');
    const landControl = this.realEstateTitleForm.get('land');
    const buildingControl = this.realEstateTitleForm.get('building');

    if (selected === 'FM' && fmControl.value) {
      pmControl.setValue(false);
    } else if (selected === 'PM' && pmControl.value) {
      fmControl.setValue(false);
    } else if (selected === 'ACQUISITION' && acquisitionControl.value) {
      disposalControl.setValue(false);
      if (landControl.value && buildingControl.value) {
        buildingControl.setValue(false);
        landControl.setValue(false);
      }
    } else if (selected === 'DISPOSAL' && disposalControl.value) {
      acquisitionControl.setValue(false);
    } else if (selected === 'LAND' && acquisitionControl.value) {
      buildingControl.setValue(false);
    } else if (selected === 'BUILDING' && acquisitionControl.value) {
      landControl.setValue(false);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle reviewMode changes
    if (this.realEstateTitleForm && changes['reviewMode']) {
      if (this.reviewMode) {
        this.realEstateTitleForm.disable();
      } else {
        this.realEstateTitleForm.enable();
      }

      if (changes['projectData']) {
        this.updateFilteredFundingTypes();
      }
    }

    // Re-evaluate funding type options when formStatus changes (e.g. rejected form loaded)
    if (this.realEstateTitleForm && (changes['formStatus'] || changes['projectData'])) {
      this.updateFilteredFundingTypes();
    }
  }

  private updateFilteredFundingTypes(): void {
    // Keep all funding types available in all stages so saved draft values remain visible
    // and PMs can move between funding types during edit flows.
    this.filteredFundingTypes = FUNDING_TYPES;

    /* Old Code Logic for Filtered Funding Types
    if (!this.realEstateTitleForm.get("realEstateDepartment") || this.reviewMode) {
      this.filteredFundingTypes = FUNDING_TYPES;
      return;
    }

    // If no previous version exists, or the form was rejected (not yet approved),
    // show only Advance and Full so the FM/PM can correct the original submission
    if (
      !this.projectData ||
      !this.projectData.project ||
      this.formStatus === "Rejected"
    ) {
      this.filteredFundingTypes = FUNDING_TYPES.filter(
        (type) => type.value === "ADVANCE" || type.value === "FULL"
      );
      return;
    }

    
    const previousFundingType = this.projectData.project.titleForm.fundingType;

    // If previous was Advance or Advance Supplemental, show Advance Supplemental and Full
    if (
      previousFundingType === "ADVANCE" ||
      previousFundingType === "ADV_SUPPLEMENTAL"
    ) {
      this.filteredFundingTypes = FUNDING_TYPES.filter(
        (type) => type.value === "ADV_SUPPLEMENTAL" || type.value === "FULL"
      );
      return;
    }

    // If previous was Full or Full Supplemental, show only Full Supplemental
    if (
      previousFundingType === "FULL" ||
      previousFundingType === "FULL_SUPPLEMENTAL"
    ) {
      this.filteredFundingTypes = FUNDING_TYPES.filter(
        (type) => type.value === "FULL_SUPPLEMENTAL"
      );
      return;
    }*/
  }
}
